import { render, staticRenderFns } from "./SaleClosedAlert.vue?vue&type=template&id=2ae4ad17"
import script from "./SaleClosedAlert.vue?vue&type=script&lang=js"
export * from "./SaleClosedAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports